<template>
    <b-tr>
		<!-- Icone indiquant l'etat de la sélection pour le facteur -->
		 <!-- A non barré : mode auto | A barré : mode manuel | Coloré : non en accord avec sélection arborescence -->
		<b-td :id="$id('factorState')" class="text-center align-middle">
			<!-- Icone fontawesome en plusieurs couches (/!\ l'ordre est important) -->
			<font-awesome-layers :role="factorSelection.AutoFilter ? '' : 'button'" v-on="factorSelection.AutoFilter ? undefined : {click : () => { setAutoMode() }}" > <!-- factorBlockFeature().SetAutoMode() -->
				<font-awesome-icon v-if="factorSelection.AutoFilter" :icon="['fas', 'circle']" size="2x" class="text-gray" transform="grow-2" /> <!-- Fond indication 'bouton' désactivé -->
				<font-awesome-icon v-else icon="slash" size="2x" transform="shrink-6 left-2 flip-v" :class="factorSelection.InWarning ? 'text-warning' : 'text-black'" /> <!-- Barre indication mode manuel-->
				<font-awesome-icon :icon="['far', 'circle']" size="2x" :class="[{'text-warning' : factorSelection.InWarning}]" /> <!-- Cercle indicatif mode erreur -->
				<font-awesome-icon icon="a" size="1x" transform="right-8" /> <!-- Lettre pour 'Auto' -->
			</font-awesome-layers>
		
			<!-- Infobulle d'information sur l'icône d'état de la selection -->
			<b-tooltip :target="$id('factorState')" noninteractive triggers="hover">
				{{ factorSelection.AutoFilter ? $t('AutoMsg') : $t('ManualMsg') }} <!-- Mode automatique/manuel -->
				<br/>
				{{ factorSelection.InWarning ? $t('InWarningMsg') : '' }} <!-- Les noeuds sélectionnés ne sont pas tous affectés à ce facteur. -->
			</b-tooltip>
		</b-td>

		<!-- Nom du noeud sélectionné -->
		<b-td class="px-0 text-center align-middle">
			{{ selectionNode.Name }}
		</b-td>

		<!-- Bouton 3 petits points pour afficher les affectations du facteurs -->
		<b-td class="align-middle">
			<b-icon @click="$emit('EditSelectionEvent', { selectionNode: selectionNode, checkedNodeIds: factorSelection.Filters })" role="button" icon="three-dots-vertical" scale="1.5" />
		</b-td>
    </b-tr>
</template>

<script lang="ts">
    import { InjectReactive, Prop, PropSync, Vue } from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import TreeNode from '@/types/TreeNode';
    import FactorSelection from '@/types/Config/Factor/Benchmarking/FactorSelection';

	// Traduction
	/** @todo AGarron Créer son propre json plutôt qu'appeler le FactorBlock.json !!! */
	import locales from "../../../locales/FactorBlock.json";

    @Component({
        i18n: { messages: locales }
    })
    export default class FactorSelectionNode extends Vue {
		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;

        private selectionNode: TreeNode;

		/** Information de la sélection actuelle d'un facteur selon un noeud précis*/
        @PropSync("FactorSelection")
        public factorSelection!: FactorSelection;

        /** Reçoit d'un parent le nom de l'instance de FilterTree à utiliser comme base de clonage pour tous les composants enfants du Workbench */
        @InjectReactive()
        private sourceFilterTree!: string;

		/**
		 * Remet les paramètres par défaut par rapport aux sélections
		 * @param factorSelection 
		 */
		setAutoMode(){
			this.factorSelection.AutoFilter = true;
			// this.factorSelection.Filters = this.factorSelection.AutoCheckedNodesIds;
			this.$emit("SelectionAutoModeEvent", this.selectionNode);
		}

        created() {
			//this.checkedNodeIds = this.factorSelection.Filters;
			// Récupération du noeud sélectionné dans l'arborescence principale
            this.selectionNode = this.$store.getters[this.sourceFilterTree + "/Node"](this.factorSelection.NodeId);
		}
    }
</script>

<style scoped>
</style>